import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Navlink from './Navlink';
import Today from './Today';
import Daily from './Daily';
import Weekly from './Weekly';
import Monthly from './Monthly';
import Yearly from './Yearly';
import './Viewers.css';


const Viewers = () => {
	return ( 
		<React.Fragment>
			<Navlink />
			<Switch>
				<Route path='/dashboard/viewers' exact component={Today}/>
				<Route path='/dashboard/viewers/daily' exact component={Daily}/>
				<Route path='/dashboard/viewers/weekly' exact component={Weekly}/>
				<Route path='/dashboard/viewers/monthly' exact component={Monthly}/>
				<Route path='/dashboard/viewers/yearly' exact component={Yearly}/>
				<Redirect to="/dashboard/not-found" />

			</Switch>
		</React.Fragment>
	 );
}
 
export default Viewers;